import React from 'react';
import { Link } from 'react-router';
import styles from './styles/Liftup.module.scss';
import ConditionalWrapper from './ConditionalWrapper';

type LiftupProps = {
  className?: string;
  link?: string;
  wrapper?: boolean;
  size?: string;
  noStyles?: boolean;
  scroll?: boolean;
  children: React.ReactNode;
};

const Liftup: React.FunctionComponent<LiftupProps> = (props: LiftupProps) => {
  const { className, link, size, noStyles, scroll, children } = props;

  return (
    <ConditionalWrapper
      condition={link}
      wrapper={(children: React.ReactNode) => {
        if (className === 'linkExternal') {
          return (
            <a href={link} target="_blank" className={styles.linkExternal}>
              {children}
            </a>
          );
        }
        if (scroll === true) {
          return (
            <a href={link} className={styles.link}>
              {children}
            </a>
          );
        }
        return (
          <Link to={link ?? ''} className={styles.link}>
            {children}
          </Link>
        );
      }}
    >
      <div className={`${className ? styles[className] : undefined} ${size ? styles[size] : ''} ${noStyles ? styles.noStyles : styles.liftup}`}>
        <div>{children}</div>
      </div>
    </ConditionalWrapper>
  );
};

export default Liftup;
